export default "__VITE_ASSET___Q1DI_db__"